import { cx } from '@linaria/core';
import { useState, useMemo, useEffect } from 'react';
import { Table } from '@ui/kit';
import { EmptyMessage } from '../atoms/empty-message.js';
import { useAppliedTimespan } from '../hook.applied-timespan.js';
import { tableCls } from '../shared.table.style.js';
import { useComponentEntrySelector } from '../state.js';
import { Item } from './table.item.js';
import { modifiers } from './table.root.style.js';
import { THead } from './table.thead.js';
import { jsx } from 'react/jsx-runtime';
import { useSortState, sortComponentEntries } from '../utils/sort.js';
import { generateTableKey } from '../utils/table-key.js';

function TeacherEntriesTable(props) {
  const [clickedItemKey, setClickedItemKey] = useState();
  const additionalProps = useMemo(() => ({
    onClick: itemKey => setClickedItemKey(prev => itemKey !== prev ? itemKey : undefined),
    withStats: props.withStats,
    isExpanded: () => true
  }), [props.withStats, setClickedItemKey]);
  const filters = useComponentEntrySelector(state => state);
  const [sort, onSort] = useSortState();
  const appliedTimespan = useAppliedTimespan();
  const tableKey = generateTableKey(filters, sort, appliedTimespan);

  // Ensure nested tables are collapsed once filtering changes as the clicked
  // item may disappear due to filtering.
  useEffect(() => {
    setClickedItemKey(undefined);
  }, [tableKey]);
  const sortedEntries = useMemo(() => [...props.entries].sort((a, b) => sortComponentEntries(sort, a.groupedEntries[0] ? {
    ...a.groupedEntries[0],
    modifiedAt: new Date(Math.max(...a.groupedEntries.map(it => it.modifiedAt?.getTime() ?? 0))),
    createdAt: new Date(Math.max(...a.groupedEntries.map(it => it.createdAt?.getTime() ?? 0)))
  } : undefined, b.groupedEntries[0] ? {
    ...b.groupedEntries[0],
    modifiedAt: new Date(Math.max(...b.groupedEntries.map(it => it.modifiedAt?.getTime() ?? 0))),
    createdAt: new Date(Math.max(...b.groupedEntries.map(it => it.createdAt?.getTime() ?? 0)))
  } : undefined)), [props.entries, sort]);
  const entries = useMemo(() => sortedEntries.map(it => ({
    ...it,
    isExpanded: clickedItemKey === it.key
  })), [clickedItemKey, sortedEntries]);
  return /*#__PURE__*/jsx(Table, {
    className: cx(tableCls, props.withStats && modifiers.withStats.className, clickedItemKey !== undefined && modifiers.hasExpandedChild.className),
    thead: /*#__PURE__*/jsx(THead, {
      options: sort,
      onSort: onSort
    }),
    contentKey: tableKey,
    items: entries,
    Item: Item,
    additionalProps: additionalProps,
    emptyMessage: /*#__PURE__*/jsx(EmptyMessage, {
      hasSearched: !!filters.query
    })
  });
}

export { TeacherEntriesTable };
//# sourceMappingURL=table.root.js.map
